import React from "react";
import PropTypes from "prop-types";
import { FaTag, FaStethoscope } from "react-icons/fa";
import { BsFillTelephoneFill, BsFillQuestionCircleFill } from "react-icons/bs";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import * as Helpers from "../../helpers";
import * as CONST from "../../helpers/Constants.js";
import {
  MdSupportAgent,
  MdWatchLater,
  MdNoteAdd,
  MdNotInterested,
  MdCheckCircle,
  MdCircleNotifications,
} from "react-icons/md";

const propTypes = {
  tags: PropTypes.array.isRequired,
};

TaskTags.prototype = propTypes;
export default function TaskTags(props) {
  function style(val) {
    let color = CONST.HEALTH_PLAN_TAG_COLOR_MAP[val] || CONST.TAG_COLOR_MAP[val] || CONST.COLOR_SET[Helpers.alphaVal(val[0])];

    return {
      color: color,
      icon: val.includes("pcp-action") ? (
        <FaStethoscope />
      ) : val.includes("wp-action") ? (
        <MdSupportAgent />
      ) : val.includes("patient-action") ? (
        <MdWatchLater />
      ) : val == "patient-requested-order" ? (
        <MdNoteAdd />
      ) : ["patient-question", "specialist-referral-question"].includes(val) ? (
        <BsFillQuestionCircleFill />
      ) : val == "patient-rejected" ? (
        <MdNotInterested />
      ) : val == "patient-reported-completed" ? (
        <MdCheckCircle />
      ) : val == "vip-hotline" ? (
        <BsFillTelephoneFill />
      ) : val == "cpr" ? (
        <MdCircleNotifications />
      ) : null,
    };
  }

  return (
    <>
      {!!props.tags.length > 0 && (
        <div style={{ "width": "100%" }}>
          <FaTag className="tag-icon-small" style={{ opacity: "0.5" }} />
          {props.tags.map((i, idx) => {
            const styles = style(i.value);
            return (
              <Chip
                key={idx}
                className="task-tag"
                icon={styles.icon}
                sx={{ bgcolor: styles.color, fontWeight: "700", color: "#fff" }}
                label={i.label}
              />
            );
          })}
        </div>
      )}
    </>
  );
}
